import { useQuery, UseQueryResult } from 'react-query';
import { SalesPortalAgreementPreview } from 'types';
import { client } from 'utils/api-client';

interface IUseSalesPortalAgreementPreviewProps {
  gym?: string;
  packageId?: string;
  billingPlanId?: string | null;
  profileId?: string | null;
  // The purchase creates a new athlete, so there is no existing athlete to describe.
  forNewAthlete?: boolean;
  // Part of the query key only: the waiver on-file check resolves server-side for
  // authenticated requesters, so signing in must refetch the same URL.
  sessionUserId?: string | null;
}

export default function useSalesPortalAgreementPreview({
  gym,
  packageId,
  billingPlanId,
  profileId,
  forNewAthlete,
  sessionUserId,
}: IUseSalesPortalAgreementPreviewProps): UseQueryResult<{ data: SalesPortalAgreementPreview }> {
  const params = new URLSearchParams();

  if (billingPlanId) {
    params.append('billing_plan_id', billingPlanId);
  }

  if (profileId) {
    params.append('profile_id', profileId);
  }

  if (forNewAthlete) {
    params.append('for_new_athlete', 'true');
  }

  return useQuery(
    ['salesPortalAgreementPreview', gym, packageId, billingPlanId, profileId, forNewAthlete, sessionUserId],
    () =>
      client.get(`sales-portal/gyms/${gym}/packages/${packageId}/agreement-preview/?${params.toString()}`),
    {
      enabled: !!gym && !!packageId,
    },
  );
}
